import "./PlaceholderCard.css";

export const PlaceholderCard = () => {
  return <div className="placeholderCard"></div>;
};
